// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Patient journeys index (Stitch Clinical Precision) ——— */
.pj-screen {
  box-sizing: border-box;
  padding: 24px;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #ffffff;
  min-height: 100%;
}

.pj-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 16px;
  border-bottom: 1px solid #F1F5F9;
}

.pj-heading__left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.pj-heading__left h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.pj-subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  color: #64748B;
}

.pj-heading__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.pj-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease;
}

.pj-btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.pj-btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.pj-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.pj-toolbar__search {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 320px;
  max-width: 540px;
  min-width: 0;
}

.pj-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 180px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
  transition: border-color 0.12s ease, background 0.12s ease, box-shadow 0.12s ease;
}

.pj-search:focus-within {
  background: #ffffff;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.pj-search__icon {
  flex-shrink: 0;
  color: #94A3B8;
  font-size: 16px;
  margin-inline-end: 8px;
}

.pj-search__input.ant-input-affix-wrapper,
.pj-search__input.ant-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 36px !important;
  padding: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 14px;
}

.pj-search-by {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  flex-shrink: 0;
}

.pj-search-by__label {
  font-size: 13px;
  color: #94A3B8;
  white-space: nowrap;
}

.pj-search-by__select.ant-select {
  min-width: 120px;
}

.pj-search-by__select .ant-select-selector {
  padding: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
}

.pj-total {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
  white-space: nowrap;
}

.pj-total strong {
  font-weight: 600;
  color: #0F172A;
}

.pj-total__dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #10B981;
}

.pj-table-card {
  box-sizing: border-box;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  min-width: 0;
}

.pj-table-scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.pj-table {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
  text-align: start;
  font-size: 14px;
}

.pj-table.is-fetching {
  opacity: 0.72;
}

.pj-table thead th {
  padding: 12px 16px;
  border-bottom: 1px solid #E2E8F0;
  background: #F8FAFC;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
}

.pj-table thead th.is-action {
  text-align: end;
  padding-inline-end: 24px;
}

.pj-table tbody td {
  padding: 16px;
  border-bottom: 1px solid #E2E8F0;
  color: #0F172A;
  vertical-align: middle;
}

.pj-table tbody tr:last-child td {
  border-bottom: none;
}

.pj-table tbody tr.is-clickable {
  cursor: pointer;
}

.pj-table tbody tr:hover td {
  background: #F8FAFC;
}

.pj-table tbody td.is-action {
  text-align: end;
  padding-inline-end: 24px;
}

.pj-id {
  font-weight: 600;
  color: #0EA5E9;
}

.pj-patient {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pj-patient__name {
  font-weight: 500;
  color: #0F172A;
}

.pj-patient__phone {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  color: #64748B;
}

.pj-clinic {
  color: #475569;
}

.pj-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
}

.pj-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.pj-status.is-open {
  background: #FFFBEB;
  color: #B45309;
  border-color: #FDE68A;
}

.pj-status.is-open .pj-status__dot {
  background: #F59E0B;
}

.pj-status.is-progress {
  background: #E0F2FE;
  color: #0369A1;
  border-color: #BAE6FD;
}

.pj-status.is-progress .pj-status__dot {
  background: #0EA5E9;
}

.pj-status.is-completed {
  background: #ECFDF5;
  color: #065F46;
  border-color: #A7F3D0;
}

.pj-status.is-completed .pj-status__dot {
  background: #10B981;
}

.pj-status.is-cancelled {
  background: #F1F5F9;
  color: #475569;
  border-color: #E2E8F0;
}

.pj-status.is-cancelled .pj-status__dot {
  background: #94A3B8;
}

.pj-steps {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pj-steps__count {
  font-weight: 600;
  color: #0F172A;
}

.pj-steps__hint {
  font-size: 12px;
  color: #64748B;
}

.pj-show-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: #ffffff;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.pj-show-btn:hover {
  background: #F8FAFC;
  border-color: #CBD5E1;
  color: #0F172A;
}

.pj-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 48px 24px;
  color: #64748B;
  font-size: 14px;
  text-align: center;
}

.pj-empty p {
  margin: 0;
}

.pj-disabled {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 24px;
  color: #64748B;
  font-size: 14px;
  text-align: center;
}

.pj-disabled p {
  margin: 0;
  max-width: 28rem;
}

.pj-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-top: 8px;
  border-top: 1px solid #F1F5F9;
}

.pj-pager__range {
  font-size: 13px;
  color: #64748B;
}

.pj-pager__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pj-pager__btn {
  box-sizing: border-box;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: #ffffff;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.pj-pager__btn:hover:not(:disabled) {
  background: #F8FAFC;
}

.pj-pager__btn:disabled {
  color: #94A3B8;
  cursor: not-allowed;
}

.pj-pager__page {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
}

.pj-pager__page.is-active {
  background: #0EA5E9;
  color: #ffffff;
}

@media (max-width: 768px) {
  .pj-screen {
    padding: 16px;
  }

  .pj-heading__left h1 {
    font-size: 20px;
  }
}

/* ——— Shared / show page (existing) ——— */
.journey-status-tag {
  margin: 0;
  width: fit-content;
  font-size: 14px;
  line-height: 22px;
  padding: 2px 10px;
}

.add-padding {
  padding-bottom: 20px !important;
}

.patient-info {
  background-color: white;
  padding: 24px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  height: 100%;
}

.journey-details-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px 32px;
}

.journey-detail {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.journey-detail-wide {
  grid-column: 1 / -1;
}

.journey-detail .step-record-link {
  width: fit-content;
  text-align: start;
}

@media (max-width: 992px) {
  .journey-details-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.append-step-card {
  background-color: white;
  padding: 20px 24px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  margin-bottom: 20px;
}

.append-step-title {
  margin-bottom: 4px;
}

.append-step-hint {
  margin-bottom: 16px;
}

.journey-steps-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.journey-steps-header .form-title {
  margin-bottom: 0;
}

.add-step-section-title {
  margin-bottom: 12px;
}

.appointment-link-table {
  margin-top: 0;
}

.appointment-clinic-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.appointment-clinic-tag.ant-tag {
  margin: 0;
  width: fit-content;
  white-space: nowrap;
}

.add-appointment-button {
  margin-top: 16px;
  height: var(--control-height);
  min-width: 160px;
  padding: 0 24px;
  border-radius: var(--radius-md);
}

.append-step-form .ant-form-item {
  margin-bottom: 12px;
}

.append-step-control {
  width: 100%;
}

.append-step-control.ant-select,
.append-step-control.ant-input-number {
  width: 100%;
}

.journey-timeline {
  background-color: white;
  padding: 24px 24px 8px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
}

.journey-timeline .ant-timeline-item-content {
  inset-inline-start: 0;
  width: calc(100% - 24px);
  margin-inline-start: 24px;
}

.journey-step-card {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 16px;
}

.journey-step-card-focus {
  border: 2px solid var(--primary-color);
  scroll-margin-top: 72px;
}

.journey-step-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.journey-step-identity,
.journey-step-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.journey-ticket {
  color: var(--primary-color);
  background: #e6f4ff;
  border-color: #91caff;
  font-weight: 600;
}

/* ——— Station Queue (Stitch Clinical Precision) ——— */
.station-queue-screen {
  box-sizing: border-box;
  padding: 24px;
  min-width: 0;
  max-width: 100%;
}

.station-queue-disabled {
  margin-top: 12px;
  text-align: center;
  color: #64748B;
}

.station-queue-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 24px;
  margin-bottom: 0;
  border-bottom: 1px solid #F1F5F9;
}

.station-queue-heading__right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.station-queue-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.station-queue-title-row h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.station-queue-live {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  background: #ECFDF5;
  color: #059669;
  border: 1px solid #A7F3D0;
}

.station-queue-live__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #10B981;
}

.station-queue-clinic {
  min-width: 160px;
}

.station-queue-clinic .ant-select-selector {
  height: 36px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  background: #ffffff !important;
}

.station-queue-call-next {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: #0284C7;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(2, 132, 199, 0.2);
}

.station-queue-call-next:hover:not(:disabled) {
  background: #0EA5E9;
}

.station-queue-call-next:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.station-queue-subtitle {
  margin: 6px 0 0;
  color: #64748B;
  font-size: 13px;
  line-height: 18px;
}

.station-queue-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  margin-bottom: 16px;
  border-bottom: 1px solid #E2E8F0;
  overflow-x: auto;
}

.station-queue-tab {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  margin-bottom: -1px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #64748B;
  font-size: 15px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.station-queue-tab:hover {
  color: #0F172A;
}

.station-queue-tab.is-active {
  color: #0EA5E9;
  font-weight: 600;
  border-bottom-color: #0EA5E9;
}

.station-queue-tab__dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #CBD5E1;
  flex-shrink: 0;
}

.station-queue-tab.is-active .station-queue-tab__dot {
  background: #0EA5E9;
}

.station-queue-count {
  padding: 2px 8px;
  border-radius: 9999px;
  background: #F1F5F9;
  color: #64748B;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.station-queue-tab.is-active .station-queue-count {
  background: #E0F2FE;
  color: #0284C7;
}

.station-queue-tabs__meta {
  margin-inline-start: auto;
  padding: 8px 4px;
  font-size: 13px;
  color: #64748B;
  white-space: nowrap;
}

.station-queue-lane-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.station-queue-lane-head__title {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #475569;
}

.station-queue-lane-head__note {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  color: #94A3B8;
}

.station-queue-lane-head__meta {
  font-size: 12px;
  color: #64748B;
  white-space: nowrap;
}

.station-queue-table-card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  min-width: 0;
  max-width: 100%;
}

.station-queue-list {
  height: auto;
  min-height: 120px;
  min-width: 0;
}

.station-queue-table-scroll {
  width: 100%;
  overflow-x: auto;
  min-width: 0;
}

.station-queue-table {
  --sq-cols: 72px minmax(180px, 1.2fr) minmax(200px, 1.4fr) minmax(150px, 1fr) 136px 140px;
  display: grid;
  grid-template-columns: var(--sq-cols);
  width: 100%;
  min-width: 900px;
  font-size: 13px;
  background: #ffffff;
}

.station-queue-table__head,
.station-queue-table__row {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: stretch;
  margin: 0;
  padding: 0;
  border-radius: 0;
  box-sizing: border-box;
}

.station-queue-table__head {
  border-bottom: 1px solid #E2E8F0;
}

.station-queue-table__head .station-queue-cell {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
  line-height: 1.2;
  background: #F8FAFC !important;
  border: 0 !important;
  border-radius: 0 !important;
}

.station-queue-table__row {
  cursor: pointer;
  border-bottom: 1px solid #F1F5F9;
}

.station-queue-table__row:last-child {
  border-bottom: 0;
}

.station-queue-table__row .station-queue-cell {
  display: flex;
  align-items: center;
  padding: 16px;
  color: #0F172A;
  min-width: 0;
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 0 !important;
  transition: background 0.12s ease;
}

.station-queue-table__row:hover .station-queue-cell {
  background: #F0F9FF !important;
}

.station-queue-table__row.is-carried .station-queue-cell {
  background: #FFFBEB !important;
}

.station-queue-table__row.is-carried:hover .station-queue-cell {
  background: #FEF3C7 !important;
}

.station-queue-cell.is-order {
  justify-content: center;
  text-align: center;
}

.station-queue-cell.is-action {
  justify-content: flex-end;
  text-align: end;
  white-space: nowrap;
}

[dir='rtl'] .station-queue-cell.is-action {
  justify-content: flex-start;
}

@media (max-width: 1100px) {
  .station-queue-table {
    --sq-cols: 64px minmax(150px, 1.1fr) minmax(160px, 1.2fr) minmax(130px, 0.9fr) 120px 128px;
  }
}

.station-order {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 700;
  font-size: 14px;
  color: #0F172A;
}

.station-order.is-hot {
  background: #E0F2FE;
  border-color: #BAE6FD;
  color: #0284C7;
}

.station-patient {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.station-patient__name {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
  color: #0F172A;
}

.station-patient__mrn {
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #64748B;
}

.station-request {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-weight: 500;
}

.station-request__dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #0EA5E9;
  flex-shrink: 0;
}

.station-request span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.station-arrival {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.station-arrival__time {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 500;
  color: #0F172A;
}

.station-arrival__wait {
  font-size: 12px;
  font-weight: 500;
  color: #0284C7;
}

.station-arrival__wait.is-amber {
  color: #D97706;
}

.station-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
}

.station-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.station-status.is-waiting {
  background: #FFFBEB;
  color: #D97706;
  border-color: #FDE68A;
}

.station-status.is-waiting .station-status__dot {
  background: #F59E0B;
}

.station-status.is-pending {
  background: #F8FAFC;
  color: #64748B;
  border-color: #E2E8F0;
}

.station-status.is-done {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.station-status.is-cancelled {
  background: #FEF2F2;
  color: #DC2626;
  border-color: #FECACA;
}

.station-row-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border-radius: 6px;
  border: 1px solid #BAE6FD;
  background: #ffffff;
  color: #0284C7;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

[dir='rtl'] .station-row-btn .anticon {
  transform: scaleX(-1);
}

.station-row-btn:hover {
  background: #F0F9FF;
}

.station-row-btn.is-primary {
  background: #0EA5E9;
  border-color: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.station-row-btn.is-primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.station-queue-empty {
  padding: 40px 24px;
  text-align: center;
  color: #94A3B8;
}

.station-queue-empty p {
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: 500;
}

.station-queue-journey-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #0F172A;
}

.station-queue-journey-caption {
  color: #64748B;
  font-size: 12px;
  line-height: 18px;
}

@media (max-width: 900px) {
  .station-queue-heading {
    flex-direction: column;
  }

  .station-queue-tabs__meta {
    display: none;
  }
}

.journey-embedded-loader {
  height: auto;
  min-height: 80px;
}

.journey-embedded-steps {
  padding: 12px 16px 16px;
}

.station-ticket-drawer .journey-embedded-steps {
  padding: 0;
}

.journey-embedded .journey-timeline,
.journey-embedded .ant-timeline {
  margin: 0;
  padding: 0;
}

.order-panel-title,
.order-line-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.journey-step-index {
  width: 28px;
  height: 28px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  font-size: 14px;
}

.journey-step-kind-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f5f5f5;
  color: #595959;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.journey-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 20px;
  border: 1px solid transparent;
  width: fit-content;
}

.journey-pill-active,
.journey-pill-in_progress {
  color: var(--primary-color);
  background: #e6f4ff;
  border-color: #91caff;
}

.journey-pill-active::before,
.journey-pill-in_progress::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--primary-color);
}

.journey-pill-pending {
  color: #d48806;
  background: #fffbe6;
  border-color: #ffe58f;
}

.journey-pill-done,
.journey-pill-finished,
.journey-pill-completed {
  color: #389e0d;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.journey-pill-cancelled,
.journey-pill-abandoned {
  color: #cf1322;
  background: #fff2f0;
  border-color: #ffccc7;
}

.journey-pill-open {
  color: var(--primary-color);
  background: #e6f4ff;
  border-color: #91caff;
}

.step-outline-button {
  height: 32px;
  border-radius: 8px;
  background: #fff;
  display: inline-flex;
  align-items: center;
}

.step-outline-done {
  color: #389e0d;
  border-color: #b7eb8f;
}

.step-outline-cancelled {
  color: #cf1322;
  border-color: #ffa39e;
}

.step-outline-active {
  color: var(--primary-color);
  border-color: #91caff;
}

.step-outline-write {
  color: var(--primary-color);
  border-color: #91caff;
}

.step-outline-view {
  color: #595959;
  border-color: #d9d9d9;
}

.order-panel {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
}

.order-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
}

.order-panel-empty {
  padding: 0 16px 12px;
}

.order-line-name .journey-step-kind-icon {
  width: 22px;
  height: 22px;
  font-size: 12px;
}

.order-lines {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.order-lines th {
  text-align: start;
  color: #8c8c8c;
  font-size: 13px;
  font-weight: 500;
  padding: 10px 16px;
  border-top: 1px solid #f0f0f0;
}

.order-lines td {
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  vertical-align: middle;
}

.order-lines-action {
  text-align: end;
}

.step-record {
  padding: 4px 8px 8px;
}

.step-record-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
  margin-bottom: 12px;
}

.service-result-text {
  white-space: pre-wrap;
  line-height: 1.6;
}

.step-record-link {
  padding: 0;
  height: auto;
}

.step-lines {
  display: flex;
  flex-direction: column;
}

.step-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
}

.step-line-name {
  min-width: 140px;
  flex: 1;
}

/* ——— Patient journey show (Stitch: Sara Nasser #88) ——— */
.pj-show {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 16px;
  background: #F8FAFC;
}

.pj-show--embedded {
  padding: 0;
  background: transparent;
  min-height: 0;
}

.pj-show__shell {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 28px;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.pj-show__hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.pj-show__hero-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.pj-show__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-top: 2px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.12s ease, color 0.12s ease;
}

.pj-show__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .pj-show__back .lucide {
  transform: scaleX(-1);
}

.pj-show__crumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 2px;
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
}

.pj-show__crumb a {
  color: #64748B;
  text-decoration: none;
}

.pj-show__crumb a:hover {
  color: #0EA5E9;
}

.pj-show__crumb-current {
  color: #0EA5E9;
}

.pj-show__title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
}

.pj-show__title {
  margin: 0;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0F172A;
  line-height: 1.25;
}

.pj-show__patient-link {
  border: none;
  background: transparent;
  padding: 0;
  font: inherit;
  font-weight: 700;
  color: inherit;
  cursor: pointer;
}

.pj-show__patient-link:hover {
  color: #0EA5E9;
}

.pj-show__title-id {
  font-size: 16px;
  font-weight: 500;
  color: #64748B;
}

.pj-show__hero-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pj-show__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.pj-show__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pj-show__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
}

.pj-show__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
  color: #0F172A;
}

.pj-show__btn--ghost .lucide {
  color: #94A3B8;
}

.pj-show__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.pj-show__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

.pj-show__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1.4;
}

.pj-show__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.pj-show__status.is-open,
.pj-show__status.is-progress {
  background: #E0F2FE;
  color: #0284C7;
  border-color: #BAE6FD;
}

.pj-show__status.is-open .pj-show__status-dot,
.pj-show__status.is-progress .pj-show__status-dot {
  background: #0EA5E9;
}

.pj-show__status.is-completed,
.pj-show__status.is-done {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.pj-show__status.is-completed .pj-show__status-dot,
.pj-show__status.is-done .pj-show__status-dot {
  background: #10B981;
}

.pj-show__status.is-waiting {
  background: #FFFBEB;
  color: #B45309;
  border-color: #FDE68A;
}

.pj-show__status.is-waiting .pj-show__status-dot {
  background: #F59E0B;
}

.pj-show__status.is-cancelled {
  background: #FEF2F2;
  color: #DC2626;
  border-color: #FECACA;
}

.pj-show__status.is-cancelled .pj-show__status-dot {
  background: #EF4444;
}

.pj-show__meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  padding: 16px;
  margin-bottom: 32px;
  border-radius: 10px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.pj-show__meta-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
}

.pj-show__meta-value {
  display: block;
  margin-top: 2px;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.pj-show__progress {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.pj-show__progress-track {
  flex: 1;
  height: 8px;
  border-radius: 9999px;
  background: #E2E8F0;
  overflow: hidden;
}

.pj-show__progress-fill {
  display: block;
  height: 100%;
  border-radius: 9999px;
  background: #0EA5E9;
}

.pj-show__progress-label {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #0284C7;
  white-space: nowrap;
}

.pj-show__steps-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.pj-show__steps-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.pj-show__steps-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0F172A;
}

.pj-show__steps-count {
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
  background: #F1F5F9;
  padding: 4px 10px;
  border-radius: 6px;
}

.pj-show__timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-inline-start: 4px;
  min-width: 0;
}

.pj-show__rail {
  position: absolute;
  inset-inline-start: 17px;
  top: 24px;
  bottom: 40px;
  width: 2px;
  background: #E2E8F0;
  z-index: 0;
  pointer-events: none;
}

.pj-show__step {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  z-index: 1;
}

.pj-show__step.is-focused .pj-show__step-card {
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.18);
}

.pj-show__node {
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
  z-index: 1;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.pj-show__node.is-done {
  background: #ECFDF5;
  border: 2px solid #10B981;
  color: #059669;
}

.pj-show__node.is-progress {
  background: #E0F2FE;
  border: 2px solid #0EA5E9;
  color: #0284C7;
  box-shadow: 0 0 0 4px rgba(224, 242, 254, 0.5);
}

.pj-show__node.is-waiting {
  background: #FFFBEB;
  border: 2px solid #F59E0B;
  color: #D97706;
}

.pj-show__node.is-cancelled {
  background: #FEF2F2;
  border: 2px solid #F87171;
  color: #DC2626;
}

.pj-show__step-card {
  flex: 1;
  min-width: 0;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.pj-show__step-card.is-progress {
  border: 2px solid rgba(14, 165, 233, 0.3);
}

.pj-show__step-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.pj-show__step-eyebrow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.pj-show__step-eyebrow > span:first-child {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748B;
}

.pj-show__step.is-progress .pj-show__step-eyebrow > span:first-child {
  color: #0EA5E9;
}

.pj-show__ticket {
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  background: #F1F5F9;
  padding: 2px 8px;
  border-radius: 4px;
}

.pj-show__step-title {
  margin: 4px 0 0;
  font-size: 17px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.3;
}

.pj-show__step-sub {
  margin: 2px 0 0;
  font-size: 13px;
  color: #475569;
  line-height: 1.4;
}

.pj-show__step-time {
  text-align: end;
  flex-shrink: 0;
}

.pj-show__step-time .pj-show__meta-label {
  font-size: 12px;
  font-weight: 400;
}

.pj-show__step-time .pj-show__meta-value {
  font-size: 13px;
}

.pj-show__record {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
}

.pj-show__record-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #64748B;
}

.pj-show__record-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #64748B;
}

.pj-show__lines {
  display: flex;
  flex-direction: column;
}

.pj-show__line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
  padding: 10px 0;
  border-top: 1px solid #F1F5F9;
}

.pj-show__line:first-child {
  border-top: none;
  padding-top: 0;
}

.pj-show__line-main {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.pj-show__line-icon {
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  background: #F1F5F9;
  color: #64748B;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pj-show__line-name {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
}

.pj-show__line-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pj-show__mini-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid transparent;
}

.pj-show__mini-pill--pending,
.pj-show__mini-pill--in_progress {
  color: #0284C7;
  background: #E0F2FE;
  border-color: #BAE6FD;
}

.pj-show__mini-pill--done,
.pj-show__mini-pill--finished {
  color: #059669;
  background: #ECFDF5;
  border-color: #A7F3D0;
}

.pj-show__mini-pill--cancelled {
  color: #DC2626;
  background: #FEF2F2;
  border-color: #FECACA;
}

.pj-show__ghost-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.pj-show__ghost-btn:hover {
  background: #F8FAFC;
  color: #0F172A;
}

.pj-show__muted {
  margin: 0;
  font-size: 13px;
  color: #64748B;
}

.pj-show__step-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #F1F5F9;
}

.pj-show__step-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.pj-show__step-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pj-show__step-btn.is-danger {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #64748B;
}

.pj-show__step-btn.is-danger:hover:not(:disabled) {
  color: #EF4444;
  background: #FEF2F2;
  border-color: #FECACA;
}

.pj-show__step-btn.is-primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
}

.pj-show__step-btn.is-primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

.pj-show__foot {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #E2E8F0;
}

.pj-show__foot-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #64748B;
  line-height: 1.45;
}

.pj-show__foot-note .lucide {
  color: #0EA5E9;
  flex-shrink: 0;
  margin-top: 1px;
}

.pj-show__empty,
.pj-show__disabled {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 24px;
  text-align: center;
  color: #64748B;
}

@media (max-width: 960px) {
  .pj-show__meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .pj-show {
    padding: 12px;
  }

  .pj-show__shell {
    padding: 16px;
  }

  .pj-show__meta {
    grid-template-columns: 1fr;
  }

  .pj-show__step {
    gap: 12px;
  }

  .pj-show__step-top {
    flex-direction: column;
  }

  .pj-show__step-time {
    text-align: start;
  }

  .pj-show__rail {
    inset-inline-start: 13px;
  }

  .pj-show__node {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
}

/* ——— Patient journey — Add step drawer (Stitch) ——— */
.pj-step-drawer.ant-drawer .ant-drawer-content-wrapper {
  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.12);
}

.pj-step-drawer .ant-drawer-header {
  display: none;
}

.pj-step-drawer .ant-drawer-body {
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.pj-step-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
}

.pj-step-drawer__header {
  flex-shrink: 0;
  padding: 16px 24px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.pj-step-drawer__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.pj-step-drawer__title-block {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.pj-step-drawer__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.25;
}

.pj-step-drawer__subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.3;
}

.pj-step-drawer__icon-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
}

.pj-step-drawer__icon-btn:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.pj-step-drawer__icon-btn--bordered {
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  color: #475569;
}

[dir='rtl'] .pj-step-drawer__icon-btn--bordered .lucide {
  transform: scaleX(-1);
}

.pj-step-drawer__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #ffffff;
}

.pj-step-drawer__banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border-radius: 8px;
  background: #F0F9FF;
  border: 1px solid #BAE6FD;
  color: #0F172A;
}

.pj-step-drawer__banner .lucide {
  color: #0EA5E9;
  flex-shrink: 0;
  margin-top: 2px;
}

.pj-step-drawer__banner p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #0F172A;
}

.pj-step-drawer__banner strong {
  color: #0284C7;
  font-weight: 600;
}

.pj-step-drawer__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pj-step-drawer__label {
  font-size: 12px;
  font-weight: 500;
  color: #0F172A;
}

.pj-step-drawer__req {
  color: #BA1A1A;
  margin-inline-start: 2px;
}

.pj-step-drawer__hint {
  margin: 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
}

.pj-step-drawer__categories {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.pj-step-drawer__category {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  text-align: start;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;
  font-family: inherit;
}

.pj-step-drawer__category:hover {
  background: #F8FAFC;
}

.pj-step-drawer__category.is-selected {
  border: 2px solid #0EA5E9;
  background: #F0F9FF;
}

.pj-step-drawer__category-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  color: #64748B;
  flex-shrink: 0;
}

.pj-step-drawer__category-icon.is-selected {
  background: #ffffff;
  border-color: #BAE6FD;
  color: #0EA5E9;
}

.pj-step-drawer__category-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}

.pj-step-drawer__category-title {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pj-step-drawer__category:not(.is-selected) .pj-step-drawer__category-title {
  font-weight: 500;
}

.pj-step-drawer__category-hint {
  font-size: 11px;
  color: #64748B;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pj-step-drawer__list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pj-step-drawer__selected-count {
  font-size: 12px;
  font-weight: 600;
  color: #94A3B8;
}

.pj-step-drawer__selected-count.is-active {
  color: #0284C7;
}

.pj-step-drawer__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}

.pj-step-drawer__card {
  box-sizing: border-box;
  width: 100%;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  text-align: start;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.12s ease, background 0.12s ease;
}

.pj-step-drawer__card:hover {
  border-color: #CBD5E1;
}

.pj-step-drawer__card.is-selected {
  border: 2px solid #0EA5E9;
  background: #F0F9FF;
  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.2);
}

.pj-step-drawer__card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pj-step-drawer__card-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pj-step-drawer__check {
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  border: 2px solid #CBD5E1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
}

.pj-step-drawer__check.is-on {
  border-color: #0EA5E9;
  background: #0EA5E9;
}

.pj-step-drawer__card-name {
  font-size: 13px;
  font-weight: 700;
  color: #0F172A;
}

.pj-step-drawer__chip {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 4px;
  background: #F1F5F9;
  color: #334155;
}

.pj-step-drawer__status {
  font-size: 12px;
  color: #64748B;
  flex-shrink: 0;
}

.pj-step-drawer__card-meta {
  margin: 8px 0 0;
  padding-inline-start: 30px;
  font-size: 12px;
  color: #475569;
}

.pj-step-drawer__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 12px;
  text-align: center;
  color: #64748B;
  font-size: 13px;
}

.pj-step-drawer__quota {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 8px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.pj-step-drawer__quota-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pj-step-drawer__control.ant-select {
  width: 100%;
}

.pj-step-drawer__control.ant-select .ant-select-selector {
  min-height: 36px !important;
  padding: 0 12px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  background: #ffffff !important;
  align-items: center;
}

.pj-step-drawer__control.ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.pj-step-drawer__control.ant-select .ant-select-selection-item,
.pj-step-drawer__control.ant-select .ant-select-selection-placeholder {
  font-size: 13px;
  line-height: 34px;
}

.pj-step-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
  box-shadow: 0 -1px 2px rgba(15, 23, 42, 0.03);
}

.pj-step-drawer__sync {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
}

.pj-step-drawer__sync-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #00B17B;
  flex-shrink: 0;
}

.pj-step-drawer__footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pj-step-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.pj-step-drawer__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pj-step-drawer__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
}

.pj-step-drawer__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
}

.pj-step-drawer__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.pj-step-drawer__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

@media (max-width: 640px) {
  .pj-step-drawer__categories {
    grid-template-columns: 1fr;
  }

  .pj-step-drawer__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .pj-step-drawer__footer-actions {
    justify-content: flex-end;
  }
}


/* ——— Patient journeys — New journey drawer (Stitch) ——— */
.pj-new-drawer.ant-drawer .ant-drawer-content-wrapper {
  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.12);
}

.pj-new-drawer .ant-drawer-header {
  display: none;
}

.pj-new-drawer .ant-drawer-body {
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.pj-new-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
}

.pj-new-drawer__header {
  flex-shrink: 0;
  padding: 16px 24px;
  border-bottom: 1px solid #E2E8F0;
}

.pj-new-drawer__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.pj-new-drawer__title-block {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.pj-new-drawer__title-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pj-new-drawer__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.pj-new-drawer__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  background: #E0F2FE;
  color: #0369A1;
  border: 1px solid #BAE6FD;
}

.pj-new-drawer__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: #64748B;
  line-height: 1.35;
}

.pj-new-drawer__icon-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
}

.pj-new-drawer__icon-btn:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .pj-new-drawer__title-block > .pj-new-drawer__icon-btn .lucide {
  transform: scaleX(-1);
}

.pj-new-drawer__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #ffffff;
}

.pj-new-drawer__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.pj-new-drawer__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pj-new-drawer__label {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
}

.pj-new-drawer__muted-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.pj-new-drawer__req {
  color: #E11D48;
  margin-inline-start: 2px;
}

.pj-new-drawer__register {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  color: #0EA5E9;
  cursor: pointer;
}

.pj-new-drawer__register:hover {
  text-decoration: underline;
}

.pj-new-drawer__search {
  position: relative;
}

.pj-new-drawer__search-icon {
  position: absolute;
  inset-inline-start: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  pointer-events: none;
}

.pj-new-drawer__search-input {
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  padding: 0 36px 0 36px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  font-size: 13px;
  font-family: inherit;
  color: #0F172A;
}

.pj-new-drawer__search-input:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.pj-new-drawer__search-input::placeholder {
  color: #94A3B8;
}

.pj-new-drawer__search-clear {
  position: absolute;
  inset-inline-end: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
}

.pj-new-drawer__search-clear:hover {
  color: #475569;
  background: #F1F5F9;
}

.pj-new-drawer__results {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 180px;
  overflow-y: auto;
}

.pj-new-drawer__result {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  text-align: start;
  cursor: pointer;
  font-family: inherit;
}

.pj-new-drawer__result:hover {
  background: #F8FAFC;
}

.pj-new-drawer__result-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}

.pj-new-drawer__result-name {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
}

.pj-new-drawer__result-meta {
  font-size: 12px;
  color: #64748B;
}

.pj-new-drawer__avatar {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #BAE6FD;
  flex-shrink: 0;
}

.pj-new-drawer__patient-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px;
  border-radius: 8px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.pj-new-drawer__patient-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.pj-new-drawer__patient-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pj-new-drawer__patient-name {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
}

.pj-new-drawer__code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  color: #64748B;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  padding: 1px 6px;
}

.pj-new-drawer__patient-meta {
  margin-top: 2px;
  font-size: 12px;
  color: #64748B;
}

.pj-new-drawer__check {
  color: #0EA5E9;
  flex-shrink: 0;
}

.pj-new-drawer__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.pj-new-drawer__control.ant-select {
  width: 100%;
}

.pj-new-drawer__control.ant-select .ant-select-selector {
  min-height: 36px !important;
  padding: 0 12px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  align-items: center;
  font-size: 13px;
}

.pj-new-drawer__control.ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.pj-new-drawer__control.ant-select .ant-select-selection-item,
.pj-new-drawer__control.ant-select .ant-select-selection-placeholder {
  font-size: 13px;
  line-height: 34px;
}

.pj-new-drawer__triage {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.pj-new-drawer__triage-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.pj-new-drawer__triage-btn:hover {
  background: #F8FAFC;
}

.pj-new-drawer__triage-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.pj-new-drawer__triage-btn.is-normal .pj-new-drawer__triage-dot {
  background: #0EA5E9;
}

.pj-new-drawer__triage-btn.is-urgent .pj-new-drawer__triage-dot {
  background: #F59E0B;
}

.pj-new-drawer__triage-btn.is-priority .pj-new-drawer__triage-dot {
  background: #EF4444;
}

.pj-new-drawer__triage-btn.is-normal.is-selected {
  border-color: #0EA5E9;
  background: #E0F2FE;
  color: #0284C7;
  font-weight: 600;
}

.pj-new-drawer__triage-btn.is-urgent.is-selected {
  border-color: #F59E0B;
  background: #FFFBEB;
  color: #B45309;
  font-weight: 600;
}

.pj-new-drawer__triage-btn.is-priority.is-selected {
  border-color: #EF4444;
  background: #FEF2F2;
  color: #B91C1C;
  font-weight: 600;
}

.pj-new-drawer__step-card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.pj-new-drawer__step-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E2E8F0;
}

.pj-new-drawer__step-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pj-new-drawer__step-num {
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0EA5E9;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.pj-new-drawer__step-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.pj-new-drawer__step-sub {
  margin: 2px 0 0;
  padding-inline-start: 28px;
  font-size: 12px;
  color: #64748B;
}

.pj-new-drawer__ready {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: #ECFDF5;
  color: #065F46;
  border: 1px solid #A7F3D0;
  white-space: nowrap;
  flex-shrink: 0;
}

.pj-new-drawer__step-cats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.pj-new-drawer__step-cat {
  box-sizing: border-box;
  height: 32px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pj-new-drawer__step-cat:hover {
  background: #F8FAFC;
}

.pj-new-drawer__step-cat.is-selected {
  border-color: #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 500;
}

.pj-new-drawer__text-input {
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  font-size: 13px;
  font-family: inherit;
  color: #0F172A;
}

.pj-new-drawer__text-input:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.pj-new-drawer__meta-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.pj-new-drawer__meta-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #E2E8F0;
}

.pj-new-drawer__meta-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748B;
}

.pj-new-drawer__meta-value {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  white-space: nowrap;
}

.pj-new-drawer__textarea.ant-input {
  border-radius: 8px;
  border-color: #E2E8F0;
  font-size: 13px;
  padding: 10px 12px;
  resize: none;
  background: #ffffff;
}

.pj-new-drawer__textarea.ant-input:focus {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.pj-new-drawer__error {
  margin: 0;
  font-size: 12px;
  color: #E11D48;
}

.pj-new-drawer__empty {
  padding: 12px;
  text-align: center;
  font-size: 13px;
  color: #64748B;
}

.pj-new-drawer__existing {
  border: 1px solid #BAE6FD;
  background: #F0F9FF;
  color: #0284C7;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  text-align: start;
  cursor: pointer;
}

.pj-new-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
  box-shadow: 0 -1px 2px rgba(15, 23, 42, 0.03);
}

.pj-new-drawer__sync {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748B;
}

.pj-new-drawer__sync-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #10B981;
  flex-shrink: 0;
}

.pj-new-drawer__footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pj-new-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.pj-new-drawer__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pj-new-drawer__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
}

.pj-new-drawer__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
  color: #0F172A;
}

.pj-new-drawer__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.pj-new-drawer__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

@media (max-width: 640px) {
  .pj-new-drawer__grid,
  .pj-new-drawer__meta-row,
  .pj-new-drawer__triage {
    grid-template-columns: 1fr;
  }

  .pj-new-drawer__step-cats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pj-new-drawer__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .pj-new-drawer__footer-actions {
    justify-content: flex-end;
  }
}

/* ——— Write / view service result drawer (Stitch Clinical Precision) ——— */
.pj-result-drawer.ant-drawer .ant-drawer-content-wrapper {
  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.08);
}

.pj-result-drawer .ant-drawer-header {
  display: none;
}

.pj-result-drawer .ant-drawer-body {
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.pj-result-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #ffffff;
}

.pj-result-drawer__header {
  flex-shrink: 0;
  padding: 16px 20px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.pj-result-drawer__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.pj-result-drawer__title-block {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pj-result-drawer__title-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.pj-result-drawer__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  color: #0F172A;
}

.pj-result-drawer__badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.pj-result-drawer__icon-btn {
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748B;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.pj-result-drawer__icon-btn:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.pj-result-drawer__icon-btn--bordered {
  border: 1px solid #E2E8F0;
  background: #ffffff;
}

[dir='rtl'] .pj-result-drawer__icon-btn--bordered .lucide {
  transform: scaleX(-1);
}

.pj-result-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
}

.pj-result-drawer__banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border-radius: 8px;
  background: #F0F9FF;
  border: 1px solid #BAE6FD;
  color: #0F172A;
}

.pj-result-drawer__banner .lucide {
  color: #0EA5E9;
  flex-shrink: 0;
  margin-top: 1px;
}

.pj-result-drawer__banner p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #475569;
}

.pj-result-drawer__service {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.pj-result-drawer__service-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #E0F2FE;
  color: #0284C7;
  flex-shrink: 0;
}

.pj-result-drawer__service-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
}

.pj-result-drawer__service-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.pj-result-drawer__service-name {
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pj-result-drawer__order-chip {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  background: #E2E8F0;
  color: #334155;
}

.pj-result-drawer__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pj-result-drawer__label {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}

.pj-result-drawer__req {
  color: #E11D48;
  margin-inline-start: 2px;
}

.pj-result-drawer__textarea,
.pj-result-drawer__view {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  font-size: 13px;
  line-height: 1.55;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #0F172A;
  white-space: pre-wrap;
  word-break: break-word;
}

.pj-result-drawer__textarea {
  resize: vertical;
  min-height: 180px;
}

.pj-result-drawer__textarea:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.pj-result-drawer__textarea::placeholder {
  color: #94A3B8;
  font-family: inherit;
}

.pj-result-drawer__view {
  background: #F8FAFC;
  min-height: 140px;
}

.pj-result-drawer__hint {
  margin: 0;
  font-size: 11px;
  color: #94A3B8;
  line-height: 1.4;
}

.pj-result-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
  box-shadow: 0 -1px 2px rgba(15, 23, 42, 0.03);
}

.pj-result-drawer__sync {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
  min-width: 0;
}

.pj-result-drawer__sync-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #10B981;
  flex-shrink: 0;
}

.pj-result-drawer__footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.pj-result-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.pj-result-drawer__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pj-result-drawer__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
}

.pj-result-drawer__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
  color: #0F172A;
}

.pj-result-drawer__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.pj-result-drawer__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

@media (max-width: 640px) {
  .pj-result-drawer__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .pj-result-drawer__footer-actions {
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PatientJourneys/style.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,0CAA0C;AAC1C;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wFAAwF;EACxF,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,0FAA0F;EAC5F;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6EAA6E;EAC7E,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA,2DAA2D;AAC3D;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,uDAAuD;AACvD;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,0DAA0D;EAC1D,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;AAGA,2DAA2D;AAC3D;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2EAA2E;AAC3E;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,6EAA6E;EAC7E,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* ——— Patient journeys index (Stitch Clinical Precision) ——— */\n.pj-screen {\n  box-sizing: border-box;\n  padding: 24px;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background: #ffffff;\n  min-height: 100%;\n}\n\n.pj-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.pj-heading__left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.pj-heading__left h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.pj-subtitle {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #64748B;\n}\n\n.pj-heading__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.pj-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease;\n}\n\n.pj-btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.pj-btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.pj-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.pj-toolbar__search {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 1 320px;\n  max-width: 540px;\n  min-width: 0;\n}\n\n.pj-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  min-width: 180px;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n  transition: border-color 0.12s ease, background 0.12s ease, box-shadow 0.12s ease;\n}\n\n.pj-search:focus-within {\n  background: #ffffff;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.pj-search__icon {\n  flex-shrink: 0;\n  color: #94A3B8;\n  font-size: 16px;\n  margin-inline-end: 8px;\n}\n\n.pj-search__input.ant-input-affix-wrapper,\n.pj-search__input.ant-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 36px !important;\n  padding: 0 !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 14px;\n}\n\n.pj-search-by {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.pj-search-by__label {\n  font-size: 13px;\n  color: #94A3B8;\n  white-space: nowrap;\n}\n\n.pj-search-by__select.ant-select {\n  min-width: 120px;\n}\n\n.pj-search-by__select .ant-select-selector {\n  padding: 0 !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.pj-total {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748B;\n  white-space: nowrap;\n}\n\n.pj-total strong {\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pj-total__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #10B981;\n}\n\n.pj-table-card {\n  box-sizing: border-box;\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  min-width: 0;\n}\n\n.pj-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.pj-table {\n  width: 100%;\n  min-width: 860px;\n  border-collapse: collapse;\n  text-align: start;\n  font-size: 14px;\n}\n\n.pj-table.is-fetching {\n  opacity: 0.72;\n}\n\n.pj-table thead th {\n  padding: 12px 16px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n}\n\n.pj-table thead th.is-action {\n  text-align: end;\n  padding-inline-end: 24px;\n}\n\n.pj-table tbody td {\n  padding: 16px;\n  border-bottom: 1px solid #E2E8F0;\n  color: #0F172A;\n  vertical-align: middle;\n}\n\n.pj-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.pj-table tbody tr.is-clickable {\n  cursor: pointer;\n}\n\n.pj-table tbody tr:hover td {\n  background: #F8FAFC;\n}\n\n.pj-table tbody td.is-action {\n  text-align: end;\n  padding-inline-end: 24px;\n}\n\n.pj-id {\n  font-weight: 600;\n  color: #0EA5E9;\n}\n\n.pj-patient {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.pj-patient__name {\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.pj-patient__phone {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pj-clinic {\n  color: #475569;\n}\n\n.pj-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.pj-status__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.pj-status.is-open {\n  background: #FFFBEB;\n  color: #B45309;\n  border-color: #FDE68A;\n}\n\n.pj-status.is-open .pj-status__dot {\n  background: #F59E0B;\n}\n\n.pj-status.is-progress {\n  background: #E0F2FE;\n  color: #0369A1;\n  border-color: #BAE6FD;\n}\n\n.pj-status.is-progress .pj-status__dot {\n  background: #0EA5E9;\n}\n\n.pj-status.is-completed {\n  background: #ECFDF5;\n  color: #065F46;\n  border-color: #A7F3D0;\n}\n\n.pj-status.is-completed .pj-status__dot {\n  background: #10B981;\n}\n\n.pj-status.is-cancelled {\n  background: #F1F5F9;\n  color: #475569;\n  border-color: #E2E8F0;\n}\n\n.pj-status.is-cancelled .pj-status__dot {\n  background: #94A3B8;\n}\n\n.pj-steps {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pj-steps__count {\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pj-steps__hint {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pj-show-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  padding: 0 14px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.pj-show-btn:hover {\n  background: #F8FAFC;\n  border-color: #CBD5E1;\n  color: #0F172A;\n}\n\n.pj-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 48px 24px;\n  color: #64748B;\n  font-size: 14px;\n  text-align: center;\n}\n\n.pj-empty p {\n  margin: 0;\n}\n\n.pj-disabled {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 48px 24px;\n  color: #64748B;\n  font-size: 14px;\n  text-align: center;\n}\n\n.pj-disabled p {\n  margin: 0;\n  max-width: 28rem;\n}\n\n.pj-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-top: 8px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.pj-pager__range {\n  font-size: 13px;\n  color: #64748B;\n}\n\n.pj-pager__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pj-pager__btn {\n  box-sizing: border-box;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.pj-pager__btn:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.pj-pager__btn:disabled {\n  color: #94A3B8;\n  cursor: not-allowed;\n}\n\n.pj-pager__page {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748B;\n}\n\n.pj-pager__page.is-active {\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n@media (max-width: 768px) {\n  .pj-screen {\n    padding: 16px;\n  }\n\n  .pj-heading__left h1 {\n    font-size: 20px;\n  }\n}\n\n/* ——— Shared / show page (existing) ——— */\n.journey-status-tag {\n  margin: 0;\n  width: fit-content;\n  font-size: 14px;\n  line-height: 22px;\n  padding: 2px 10px;\n}\n\n.add-padding {\n  padding-bottom: 20px !important;\n}\n\n.patient-info {\n  background-color: white;\n  padding: 24px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  height: 100%;\n}\n\n.journey-details-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 24px 32px;\n}\n\n.journey-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.journey-detail-wide {\n  grid-column: 1 / -1;\n}\n\n.journey-detail .step-record-link {\n  width: fit-content;\n  text-align: start;\n}\n\n@media (max-width: 992px) {\n  .journey-details-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.append-step-card {\n  background-color: white;\n  padding: 20px 24px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  margin-bottom: 20px;\n}\n\n.append-step-title {\n  margin-bottom: 4px;\n}\n\n.append-step-hint {\n  margin-bottom: 16px;\n}\n\n.journey-steps-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.journey-steps-header .form-title {\n  margin-bottom: 0;\n}\n\n.add-step-section-title {\n  margin-bottom: 12px;\n}\n\n.appointment-link-table {\n  margin-top: 0;\n}\n\n.appointment-clinic-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.appointment-clinic-tag.ant-tag {\n  margin: 0;\n  width: fit-content;\n  white-space: nowrap;\n}\n\n.add-appointment-button {\n  margin-top: 16px;\n  height: var(--control-height);\n  min-width: 160px;\n  padding: 0 24px;\n  border-radius: var(--radius-md);\n}\n\n.append-step-form .ant-form-item {\n  margin-bottom: 12px;\n}\n\n.append-step-control {\n  width: 100%;\n}\n\n.append-step-control.ant-select,\n.append-step-control.ant-input-number {\n  width: 100%;\n}\n\n.journey-timeline {\n  background-color: white;\n  padding: 24px 24px 8px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n}\n\n.journey-timeline .ant-timeline-item-content {\n  inset-inline-start: 0;\n  width: calc(100% - 24px);\n  margin-inline-start: 24px;\n}\n\n.journey-step-card {\n  background: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.journey-step-card-focus {\n  border: 2px solid var(--primary-color);\n  scroll-margin-top: 72px;\n}\n\n.journey-step-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.journey-step-identity,\n.journey-step-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.journey-ticket {\n  color: var(--primary-color);\n  background: #e6f4ff;\n  border-color: #91caff;\n  font-weight: 600;\n}\n\n/* ——— Station Queue (Stitch Clinical Precision) ——— */\n.station-queue-screen {\n  box-sizing: border-box;\n  padding: 24px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.station-queue-disabled {\n  margin-top: 12px;\n  text-align: center;\n  color: #64748B;\n}\n\n.station-queue-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 24px;\n  margin-bottom: 0;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.station-queue-heading__right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.station-queue-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.station-queue-title-row h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.station-queue-live {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  background: #ECFDF5;\n  color: #059669;\n  border: 1px solid #A7F3D0;\n}\n\n.station-queue-live__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #10B981;\n}\n\n.station-queue-clinic {\n  min-width: 160px;\n}\n\n.station-queue-clinic .ant-select-selector {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  background: #ffffff !important;\n}\n\n.station-queue-call-next {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 16px;\n  border: none;\n  border-radius: 8px;\n  background: #0284C7;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 1px 2px rgba(2, 132, 199, 0.2);\n}\n\n.station-queue-call-next:hover:not(:disabled) {\n  background: #0EA5E9;\n}\n\n.station-queue-call-next:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.station-queue-subtitle {\n  margin: 6px 0 0;\n  color: #64748B;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.station-queue-tabs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 24px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #E2E8F0;\n  overflow-x: auto;\n}\n\n.station-queue-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  margin-bottom: -1px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: #64748B;\n  font-size: 15px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.station-queue-tab:hover {\n  color: #0F172A;\n}\n\n.station-queue-tab.is-active {\n  color: #0EA5E9;\n  font-weight: 600;\n  border-bottom-color: #0EA5E9;\n}\n\n.station-queue-tab__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #CBD5E1;\n  flex-shrink: 0;\n}\n\n.station-queue-tab.is-active .station-queue-tab__dot {\n  background: #0EA5E9;\n}\n\n.station-queue-count {\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background: #F1F5F9;\n  color: #64748B;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.station-queue-tab.is-active .station-queue-count {\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.station-queue-tabs__meta {\n  margin-inline-start: auto;\n  padding: 8px 4px;\n  font-size: 13px;\n  color: #64748B;\n  white-space: nowrap;\n}\n\n.station-queue-lane-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.station-queue-lane-head__title {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #475569;\n}\n\n.station-queue-lane-head__note {\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: 0;\n  color: #94A3B8;\n}\n\n.station-queue-lane-head__meta {\n  font-size: 12px;\n  color: #64748B;\n  white-space: nowrap;\n}\n\n.station-queue-table-card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  min-width: 0;\n  max-width: 100%;\n}\n\n.station-queue-list {\n  height: auto;\n  min-height: 120px;\n  min-width: 0;\n}\n\n.station-queue-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  min-width: 0;\n}\n\n.station-queue-table {\n  --sq-cols: 72px minmax(180px, 1.2fr) minmax(200px, 1.4fr) minmax(150px, 1fr) 136px 140px;\n  display: grid;\n  grid-template-columns: var(--sq-cols);\n  width: 100%;\n  min-width: 900px;\n  font-size: 13px;\n  background: #ffffff;\n}\n\n.station-queue-table__head,\n.station-queue-table__row {\n  display: grid;\n  grid-template-columns: subgrid;\n  grid-column: 1 / -1;\n  align-items: stretch;\n  margin: 0;\n  padding: 0;\n  border-radius: 0;\n  box-sizing: border-box;\n}\n\n.station-queue-table__head {\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.station-queue-table__head .station-queue-cell {\n  display: flex;\n  align-items: center;\n  padding: 14px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n  line-height: 1.2;\n  background: #F8FAFC !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n}\n\n.station-queue-table__row {\n  cursor: pointer;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.station-queue-table__row:last-child {\n  border-bottom: 0;\n}\n\n.station-queue-table__row .station-queue-cell {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  color: #0F172A;\n  min-width: 0;\n  background: #ffffff !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  transition: background 0.12s ease;\n}\n\n.station-queue-table__row:hover .station-queue-cell {\n  background: #F0F9FF !important;\n}\n\n.station-queue-table__row.is-carried .station-queue-cell {\n  background: #FFFBEB !important;\n}\n\n.station-queue-table__row.is-carried:hover .station-queue-cell {\n  background: #FEF3C7 !important;\n}\n\n.station-queue-cell.is-order {\n  justify-content: center;\n  text-align: center;\n}\n\n.station-queue-cell.is-action {\n  justify-content: flex-end;\n  text-align: end;\n  white-space: nowrap;\n}\n\n[dir='rtl'] .station-queue-cell.is-action {\n  justify-content: flex-start;\n}\n\n@media (max-width: 1100px) {\n  .station-queue-table {\n    --sq-cols: 64px minmax(150px, 1.1fr) minmax(160px, 1.2fr) minmax(130px, 0.9fr) 120px 128px;\n  }\n}\n\n.station-order {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  background: #F1F5F9;\n  border: 1px solid #E2E8F0;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 700;\n  font-size: 14px;\n  color: #0F172A;\n}\n\n.station-order.is-hot {\n  background: #E0F2FE;\n  border-color: #BAE6FD;\n  color: #0284C7;\n}\n\n.station-patient {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.station-patient__name {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #0F172A;\n}\n\n.station-patient__mrn {\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #64748B;\n}\n\n.station-request {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  font-weight: 500;\n}\n\n.station-request__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.station-request span:last-child {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.station-arrival {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.station-arrival__time {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.station-arrival__wait {\n  font-size: 12px;\n  font-weight: 500;\n  color: #0284C7;\n}\n\n.station-arrival__wait.is-amber {\n  color: #D97706;\n}\n\n.station-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  padding: 0 12px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.station-status__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.station-status.is-waiting {\n  background: #FFFBEB;\n  color: #D97706;\n  border-color: #FDE68A;\n}\n\n.station-status.is-waiting .station-status__dot {\n  background: #F59E0B;\n}\n\n.station-status.is-pending {\n  background: #F8FAFC;\n  color: #64748B;\n  border-color: #E2E8F0;\n}\n\n.station-status.is-done {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.station-status.is-cancelled {\n  background: #FEF2F2;\n  color: #DC2626;\n  border-color: #FECACA;\n}\n\n.station-row-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 14px;\n  border-radius: 6px;\n  border: 1px solid #BAE6FD;\n  background: #ffffff;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n[dir='rtl'] .station-row-btn .anticon {\n  transform: scaleX(-1);\n}\n\n.station-row-btn:hover {\n  background: #F0F9FF;\n}\n\n.station-row-btn.is-primary {\n  background: #0EA5E9;\n  border-color: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.station-row-btn.is-primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.station-queue-empty {\n  padding: 40px 24px;\n  text-align: center;\n  color: #94A3B8;\n}\n\n.station-queue-empty p {\n  margin: 8px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.station-queue-journey-title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  color: #0F172A;\n}\n\n.station-queue-journey-caption {\n  color: #64748B;\n  font-size: 12px;\n  line-height: 18px;\n}\n\n@media (max-width: 900px) {\n  .station-queue-heading {\n    flex-direction: column;\n  }\n\n  .station-queue-tabs__meta {\n    display: none;\n  }\n}\n\n.journey-embedded-loader {\n  height: auto;\n  min-height: 80px;\n}\n\n.journey-embedded-steps {\n  padding: 12px 16px 16px;\n}\n\n.station-ticket-drawer .journey-embedded-steps {\n  padding: 0;\n}\n\n.journey-embedded .journey-timeline,\n.journey-embedded .ant-timeline {\n  margin: 0;\n  padding: 0;\n}\n\n.order-panel-title,\n.order-line-name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.journey-step-index {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #8c8c8c;\n  font-size: 14px;\n}\n\n.journey-step-kind-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #f5f5f5;\n  color: #595959;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.journey-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  line-height: 20px;\n  border: 1px solid transparent;\n  width: fit-content;\n}\n\n.journey-pill-active,\n.journey-pill-in_progress {\n  color: var(--primary-color);\n  background: #e6f4ff;\n  border-color: #91caff;\n}\n\n.journey-pill-active::before,\n.journey-pill-in_progress::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--primary-color);\n}\n\n.journey-pill-pending {\n  color: #d48806;\n  background: #fffbe6;\n  border-color: #ffe58f;\n}\n\n.journey-pill-done,\n.journey-pill-finished,\n.journey-pill-completed {\n  color: #389e0d;\n  background: #f6ffed;\n  border-color: #b7eb8f;\n}\n\n.journey-pill-cancelled,\n.journey-pill-abandoned {\n  color: #cf1322;\n  background: #fff2f0;\n  border-color: #ffccc7;\n}\n\n.journey-pill-open {\n  color: var(--primary-color);\n  background: #e6f4ff;\n  border-color: #91caff;\n}\n\n.step-outline-button {\n  height: 32px;\n  border-radius: 8px;\n  background: #fff;\n  display: inline-flex;\n  align-items: center;\n}\n\n.step-outline-done {\n  color: #389e0d;\n  border-color: #b7eb8f;\n}\n\n.step-outline-cancelled {\n  color: #cf1322;\n  border-color: #ffa39e;\n}\n\n.step-outline-active {\n  color: var(--primary-color);\n  border-color: #91caff;\n}\n\n.step-outline-write {\n  color: var(--primary-color);\n  border-color: #91caff;\n}\n\n.step-outline-view {\n  color: #595959;\n  border-color: #d9d9d9;\n}\n\n.order-panel {\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.order-panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 16px;\n}\n\n.order-panel-empty {\n  padding: 0 16px 12px;\n}\n\n.order-line-name .journey-step-kind-icon {\n  width: 22px;\n  height: 22px;\n  font-size: 12px;\n}\n\n.order-lines {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.order-lines th {\n  text-align: start;\n  color: #8c8c8c;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 10px 16px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.order-lines td {\n  padding: 12px 16px;\n  border-top: 1px solid #f0f0f0;\n  vertical-align: middle;\n}\n\n.order-lines-action {\n  text-align: end;\n}\n\n.step-record {\n  padding: 4px 8px 8px;\n}\n\n.step-record-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 20px;\n  margin-bottom: 12px;\n}\n\n.service-result-text {\n  white-space: pre-wrap;\n  line-height: 1.6;\n}\n\n.step-record-link {\n  padding: 0;\n  height: auto;\n}\n\n.step-lines {\n  display: flex;\n  flex-direction: column;\n}\n\n.step-line {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 16px;\n  padding: 8px 0;\n  border-top: 1px solid #f0f0f0;\n}\n\n.step-line-name {\n  min-width: 140px;\n  flex: 1;\n}\n\n/* ——— Patient journey show (Stitch: Sara Nasser #88) ——— */\n.pj-show {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  padding: 16px;\n  background: #F8FAFC;\n}\n\n.pj-show--embedded {\n  padding: 0;\n  background: transparent;\n  min-height: 0;\n}\n\n.pj-show__shell {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 28px;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.pj-show__hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.pj-show__hero-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.pj-show__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin-top: 2px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.pj-show__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .pj-show__back .lucide {\n  transform: scaleX(-1);\n}\n\n.pj-show__crumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 2px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.pj-show__crumb a {\n  color: #64748B;\n  text-decoration: none;\n}\n\n.pj-show__crumb a:hover {\n  color: #0EA5E9;\n}\n\n.pj-show__crumb-current {\n  color: #0EA5E9;\n}\n\n.pj-show__title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  min-width: 0;\n}\n\n.pj-show__title {\n  margin: 0;\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.pj-show__patient-link {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font: inherit;\n  font-weight: 700;\n  color: inherit;\n  cursor: pointer;\n}\n\n.pj-show__patient-link:hover {\n  color: #0EA5E9;\n}\n\n.pj-show__title-id {\n  font-size: 16px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.pj-show__hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pj-show__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.pj-show__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pj-show__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.pj-show__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.pj-show__btn--ghost .lucide {\n  color: #94A3B8;\n}\n\n.pj-show__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.pj-show__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.pj-show__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.pj-show__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.pj-show__status.is-open,\n.pj-show__status.is-progress {\n  background: #E0F2FE;\n  color: #0284C7;\n  border-color: #BAE6FD;\n}\n\n.pj-show__status.is-open .pj-show__status-dot,\n.pj-show__status.is-progress .pj-show__status-dot {\n  background: #0EA5E9;\n}\n\n.pj-show__status.is-completed,\n.pj-show__status.is-done {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.pj-show__status.is-completed .pj-show__status-dot,\n.pj-show__status.is-done .pj-show__status-dot {\n  background: #10B981;\n}\n\n.pj-show__status.is-waiting {\n  background: #FFFBEB;\n  color: #B45309;\n  border-color: #FDE68A;\n}\n\n.pj-show__status.is-waiting .pj-show__status-dot {\n  background: #F59E0B;\n}\n\n.pj-show__status.is-cancelled {\n  background: #FEF2F2;\n  color: #DC2626;\n  border-color: #FECACA;\n}\n\n.pj-show__status.is-cancelled .pj-show__status-dot {\n  background: #EF4444;\n}\n\n.pj-show__meta {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n  padding: 16px;\n  margin-bottom: 32px;\n  border-radius: 10px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n}\n\n.pj-show__meta-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.pj-show__meta-value {\n  display: block;\n  margin-top: 2px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pj-show__progress {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.pj-show__progress-track {\n  flex: 1;\n  height: 8px;\n  border-radius: 9999px;\n  background: #E2E8F0;\n  overflow: hidden;\n}\n\n.pj-show__progress-fill {\n  display: block;\n  height: 100%;\n  border-radius: 9999px;\n  background: #0EA5E9;\n}\n\n.pj-show__progress-label {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0284C7;\n  white-space: nowrap;\n}\n\n.pj-show__steps-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.pj-show__steps-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.pj-show__steps-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0F172A;\n}\n\n.pj-show__steps-count {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n  background: #F1F5F9;\n  padding: 4px 10px;\n  border-radius: 6px;\n}\n\n.pj-show__timeline {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding-inline-start: 4px;\n  min-width: 0;\n}\n\n.pj-show__rail {\n  position: absolute;\n  inset-inline-start: 17px;\n  top: 24px;\n  bottom: 40px;\n  width: 2px;\n  background: #E2E8F0;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.pj-show__step {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  z-index: 1;\n}\n\n.pj-show__step.is-focused .pj-show__step-card {\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.18);\n}\n\n.pj-show__node {\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  border-radius: 9999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  flex-shrink: 0;\n  z-index: 1;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.pj-show__node.is-done {\n  background: #ECFDF5;\n  border: 2px solid #10B981;\n  color: #059669;\n}\n\n.pj-show__node.is-progress {\n  background: #E0F2FE;\n  border: 2px solid #0EA5E9;\n  color: #0284C7;\n  box-shadow: 0 0 0 4px rgba(224, 242, 254, 0.5);\n}\n\n.pj-show__node.is-waiting {\n  background: #FFFBEB;\n  border: 2px solid #F59E0B;\n  color: #D97706;\n}\n\n.pj-show__node.is-cancelled {\n  background: #FEF2F2;\n  border: 2px solid #F87171;\n  color: #DC2626;\n}\n\n.pj-show__step-card {\n  flex: 1;\n  min-width: 0;\n  padding: 20px;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.pj-show__step-card.is-progress {\n  border: 2px solid rgba(14, 165, 233, 0.3);\n}\n\n.pj-show__step-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.pj-show__step-eyebrow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.pj-show__step-eyebrow > span:first-child {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.pj-show__step.is-progress .pj-show__step-eyebrow > span:first-child {\n  color: #0EA5E9;\n}\n\n.pj-show__ticket {\n  font-size: 11px;\n  font-weight: 600;\n  color: #475569;\n  background: #F1F5F9;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.pj-show__step-title {\n  margin: 4px 0 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.pj-show__step-sub {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: #475569;\n  line-height: 1.4;\n}\n\n.pj-show__step-time {\n  text-align: end;\n  flex-shrink: 0;\n}\n\n.pj-show__step-time .pj-show__meta-label {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.pj-show__step-time .pj-show__meta-value {\n  font-size: 13px;\n}\n\n.pj-show__record {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.pj-show__record-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n  font-size: 13px;\n  color: #64748B;\n}\n\n.pj-show__record-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 12px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  color: #64748B;\n}\n\n.pj-show__lines {\n  display: flex;\n  flex-direction: column;\n}\n\n.pj-show__line {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px 16px;\n  padding: 10px 0;\n  border-top: 1px solid #F1F5F9;\n}\n\n.pj-show__line:first-child {\n  border-top: none;\n  padding-top: 0;\n}\n\n.pj-show__line-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pj-show__line-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 9999px;\n  background: #F1F5F9;\n  color: #64748B;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.pj-show__line-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pj-show__line-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pj-show__mini-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid transparent;\n}\n\n.pj-show__mini-pill--pending,\n.pj-show__mini-pill--in_progress {\n  color: #0284C7;\n  background: #E0F2FE;\n  border-color: #BAE6FD;\n}\n\n.pj-show__mini-pill--done,\n.pj-show__mini-pill--finished {\n  color: #059669;\n  background: #ECFDF5;\n  border-color: #A7F3D0;\n}\n\n.pj-show__mini-pill--cancelled {\n  color: #DC2626;\n  background: #FEF2F2;\n  border-color: #FECACA;\n}\n\n.pj-show__ghost-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.pj-show__ghost-btn:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.pj-show__muted {\n  margin: 0;\n  font-size: 13px;\n  color: #64748B;\n}\n\n.pj-show__step-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.pj-show__step-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.pj-show__step-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pj-show__step-btn.is-danger {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #64748B;\n}\n\n.pj-show__step-btn.is-danger:hover:not(:disabled) {\n  color: #EF4444;\n  background: #FEF2F2;\n  border-color: #FECACA;\n}\n\n.pj-show__step-btn.is-primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.pj-show__step-btn.is-primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.pj-show__foot {\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.pj-show__foot-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.45;\n}\n\n.pj-show__foot-note .lucide {\n  color: #0EA5E9;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.pj-show__empty,\n.pj-show__disabled {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 48px 24px;\n  text-align: center;\n  color: #64748B;\n}\n\n@media (max-width: 960px) {\n  .pj-show__meta {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .pj-show {\n    padding: 12px;\n  }\n\n  .pj-show__shell {\n    padding: 16px;\n  }\n\n  .pj-show__meta {\n    grid-template-columns: 1fr;\n  }\n\n  .pj-show__step {\n    gap: 12px;\n  }\n\n  .pj-show__step-top {\n    flex-direction: column;\n  }\n\n  .pj-show__step-time {\n    text-align: start;\n  }\n\n  .pj-show__rail {\n    inset-inline-start: 13px;\n  }\n\n  .pj-show__node {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n}\n\n/* ——— Patient journey — Add step drawer (Stitch) ——— */\n.pj-step-drawer.ant-drawer .ant-drawer-content-wrapper {\n  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.12);\n}\n\n.pj-step-drawer .ant-drawer-header {\n  display: none;\n}\n\n.pj-step-drawer .ant-drawer-body {\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n.pj-step-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #ffffff;\n}\n\n.pj-step-drawer__header {\n  flex-shrink: 0;\n  padding: 16px 24px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.pj-step-drawer__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.pj-step-drawer__title-block {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.pj-step-drawer__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.pj-step-drawer__subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.pj-step-drawer__icon-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.pj-step-drawer__icon-btn:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.pj-step-drawer__icon-btn--bordered {\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  color: #475569;\n}\n\n[dir='rtl'] .pj-step-drawer__icon-btn--bordered .lucide {\n  transform: scaleX(-1);\n}\n\n.pj-step-drawer__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background: #ffffff;\n}\n\n.pj-step-drawer__banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px;\n  border-radius: 8px;\n  background: #F0F9FF;\n  border: 1px solid #BAE6FD;\n  color: #0F172A;\n}\n\n.pj-step-drawer__banner .lucide {\n  color: #0EA5E9;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.pj-step-drawer__banner p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #0F172A;\n}\n\n.pj-step-drawer__banner strong {\n  color: #0284C7;\n  font-weight: 600;\n}\n\n.pj-step-drawer__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pj-step-drawer__label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.pj-step-drawer__req {\n  color: #BA1A1A;\n  margin-inline-start: 2px;\n}\n\n.pj-step-drawer__hint {\n  margin: 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.pj-step-drawer__categories {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.pj-step-drawer__category {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  text-align: start;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease;\n  font-family: inherit;\n}\n\n.pj-step-drawer__category:hover {\n  background: #F8FAFC;\n}\n\n.pj-step-drawer__category.is-selected {\n  border: 2px solid #0EA5E9;\n  background: #F0F9FF;\n}\n\n.pj-step-drawer__category-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n  color: #64748B;\n  flex-shrink: 0;\n}\n\n.pj-step-drawer__category-icon.is-selected {\n  background: #ffffff;\n  border-color: #BAE6FD;\n  color: #0EA5E9;\n}\n\n.pj-step-drawer__category-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  gap: 1px;\n}\n\n.pj-step-drawer__category-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pj-step-drawer__category:not(.is-selected) .pj-step-drawer__category-title {\n  font-weight: 500;\n}\n\n.pj-step-drawer__category-hint {\n  font-size: 11px;\n  color: #64748B;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pj-step-drawer__list-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.pj-step-drawer__selected-count {\n  font-size: 12px;\n  font-weight: 600;\n  color: #94A3B8;\n}\n\n.pj-step-drawer__selected-count.is-active {\n  color: #0284C7;\n}\n\n.pj-step-drawer__list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.pj-step-drawer__card {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  text-align: start;\n  cursor: pointer;\n  font-family: inherit;\n  transition: border-color 0.12s ease, background 0.12s ease;\n}\n\n.pj-step-drawer__card:hover {\n  border-color: #CBD5E1;\n}\n\n.pj-step-drawer__card.is-selected {\n  border: 2px solid #0EA5E9;\n  background: #F0F9FF;\n  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.2);\n}\n\n.pj-step-drawer__card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.pj-step-drawer__card-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pj-step-drawer__check {\n  width: 20px;\n  height: 20px;\n  border-radius: 9999px;\n  border: 2px solid #CBD5E1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #ffffff;\n}\n\n.pj-step-drawer__check.is-on {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n}\n\n.pj-step-drawer__card-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0F172A;\n}\n\n.pj-step-drawer__chip {\n  font-size: 11px;\n  font-weight: 500;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #F1F5F9;\n  color: #334155;\n}\n\n.pj-step-drawer__status {\n  font-size: 12px;\n  color: #64748B;\n  flex-shrink: 0;\n}\n\n.pj-step-drawer__card-meta {\n  margin: 8px 0 0;\n  padding-inline-start: 30px;\n  font-size: 12px;\n  color: #475569;\n}\n\n.pj-step-drawer__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 24px 12px;\n  text-align: center;\n  color: #64748B;\n  font-size: 13px;\n}\n\n.pj-step-drawer__quota {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  border-radius: 8px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n}\n\n.pj-step-drawer__quota-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.pj-step-drawer__control.ant-select {\n  width: 100%;\n}\n\n.pj-step-drawer__control.ant-select .ant-select-selector {\n  min-height: 36px !important;\n  padding: 0 12px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  background: #ffffff !important;\n  align-items: center;\n}\n\n.pj-step-drawer__control.ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.pj-step-drawer__control.ant-select .ant-select-selection-item,\n.pj-step-drawer__control.ant-select .ant-select-selection-placeholder {\n  font-size: 13px;\n  line-height: 34px;\n}\n\n.pj-step-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n  box-shadow: 0 -1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.pj-step-drawer__sync {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.pj-step-drawer__sync-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #00B17B;\n  flex-shrink: 0;\n}\n\n.pj-step-drawer__footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pj-step-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.pj-step-drawer__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pj-step-drawer__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.pj-step-drawer__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.pj-step-drawer__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.pj-step-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n@media (max-width: 640px) {\n  .pj-step-drawer__categories {\n    grid-template-columns: 1fr;\n  }\n\n  .pj-step-drawer__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pj-step-drawer__footer-actions {\n    justify-content: flex-end;\n  }\n}\n\n\n/* ——— Patient journeys — New journey drawer (Stitch) ——— */\n.pj-new-drawer.ant-drawer .ant-drawer-content-wrapper {\n  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.12);\n}\n\n.pj-new-drawer .ant-drawer-header {\n  display: none;\n}\n\n.pj-new-drawer .ant-drawer-body {\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n.pj-new-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #ffffff;\n}\n\n.pj-new-drawer__header {\n  flex-shrink: 0;\n  padding: 16px 24px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.pj-new-drawer__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.pj-new-drawer__title-block {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.pj-new-drawer__title-line {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.pj-new-drawer__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.pj-new-drawer__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  background: #E0F2FE;\n  color: #0369A1;\n  border: 1px solid #BAE6FD;\n}\n\n.pj-new-drawer__subtitle {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: #64748B;\n  line-height: 1.35;\n}\n\n.pj-new-drawer__icon-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.pj-new-drawer__icon-btn:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .pj-new-drawer__title-block > .pj-new-drawer__icon-btn .lucide {\n  transform: scaleX(-1);\n}\n\n.pj-new-drawer__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  background: #ffffff;\n}\n\n.pj-new-drawer__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.pj-new-drawer__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.pj-new-drawer__label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pj-new-drawer__muted-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.pj-new-drawer__req {\n  color: #E11D48;\n  margin-inline-start: 2px;\n}\n\n.pj-new-drawer__register {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  color: #0EA5E9;\n  cursor: pointer;\n}\n\n.pj-new-drawer__register:hover {\n  text-decoration: underline;\n}\n\n.pj-new-drawer__search {\n  position: relative;\n}\n\n.pj-new-drawer__search-icon {\n  position: absolute;\n  inset-inline-start: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94A3B8;\n  pointer-events: none;\n}\n\n.pj-new-drawer__search-input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 36px;\n  padding: 0 36px 0 36px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  font-size: 13px;\n  font-family: inherit;\n  color: #0F172A;\n}\n\n.pj-new-drawer__search-input:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.pj-new-drawer__search-input::placeholder {\n  color: #94A3B8;\n}\n\n.pj-new-drawer__search-clear {\n  position: absolute;\n  inset-inline-end: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n}\n\n.pj-new-drawer__search-clear:hover {\n  color: #475569;\n  background: #F1F5F9;\n}\n\n.pj-new-drawer__results {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.pj-new-drawer__result {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  text-align: start;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.pj-new-drawer__result:hover {\n  background: #F8FAFC;\n}\n\n.pj-new-drawer__result-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  gap: 1px;\n}\n\n.pj-new-drawer__result-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pj-new-drawer__result-meta {\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pj-new-drawer__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 9999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid #BAE6FD;\n  flex-shrink: 0;\n}\n\n.pj-new-drawer__patient-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px;\n  border-radius: 8px;\n  background: #F8FAFC;\n  border: 1px solid #E2E8F0;\n}\n\n.pj-new-drawer__patient-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.pj-new-drawer__patient-name-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.pj-new-drawer__patient-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pj-new-drawer__code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  color: #64748B;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  padding: 1px 6px;\n}\n\n.pj-new-drawer__patient-meta {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pj-new-drawer__check {\n  color: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.pj-new-drawer__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.pj-new-drawer__control.ant-select {\n  width: 100%;\n}\n\n.pj-new-drawer__control.ant-select .ant-select-selector {\n  min-height: 36px !important;\n  padding: 0 12px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  align-items: center;\n  font-size: 13px;\n}\n\n.pj-new-drawer__control.ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.pj-new-drawer__control.ant-select .ant-select-selection-item,\n.pj-new-drawer__control.ant-select .ant-select-selection-placeholder {\n  font-size: 13px;\n  line-height: 34px;\n}\n\n.pj-new-drawer__triage {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.pj-new-drawer__triage-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.pj-new-drawer__triage-btn:hover {\n  background: #F8FAFC;\n}\n\n.pj-new-drawer__triage-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  flex-shrink: 0;\n}\n\n.pj-new-drawer__triage-btn.is-normal .pj-new-drawer__triage-dot {\n  background: #0EA5E9;\n}\n\n.pj-new-drawer__triage-btn.is-urgent .pj-new-drawer__triage-dot {\n  background: #F59E0B;\n}\n\n.pj-new-drawer__triage-btn.is-priority .pj-new-drawer__triage-dot {\n  background: #EF4444;\n}\n\n.pj-new-drawer__triage-btn.is-normal.is-selected {\n  border-color: #0EA5E9;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-weight: 600;\n}\n\n.pj-new-drawer__triage-btn.is-urgent.is-selected {\n  border-color: #F59E0B;\n  background: #FFFBEB;\n  color: #B45309;\n  font-weight: 600;\n}\n\n.pj-new-drawer__triage-btn.is-priority.is-selected {\n  border-color: #EF4444;\n  background: #FEF2F2;\n  color: #B91C1C;\n  font-weight: 600;\n}\n\n.pj-new-drawer__step-card {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.pj-new-drawer__step-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.pj-new-drawer__step-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pj-new-drawer__step-num {\n  width: 20px;\n  height: 20px;\n  border-radius: 9999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.pj-new-drawer__step-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.pj-new-drawer__step-sub {\n  margin: 2px 0 0;\n  padding-inline-start: 28px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pj-new-drawer__ready {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  background: #ECFDF5;\n  color: #065F46;\n  border: 1px solid #A7F3D0;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.pj-new-drawer__step-cats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.pj-new-drawer__step-cat {\n  box-sizing: border-box;\n  height: 32px;\n  padding: 0 8px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pj-new-drawer__step-cat:hover {\n  background: #F8FAFC;\n}\n\n.pj-new-drawer__step-cat.is-selected {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.pj-new-drawer__text-input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  font-size: 13px;\n  font-family: inherit;\n  color: #0F172A;\n}\n\n.pj-new-drawer__text-input:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.pj-new-drawer__meta-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.pj-new-drawer__meta-chip {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n}\n\n.pj-new-drawer__meta-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pj-new-drawer__meta-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  white-space: nowrap;\n}\n\n.pj-new-drawer__textarea.ant-input {\n  border-radius: 8px;\n  border-color: #E2E8F0;\n  font-size: 13px;\n  padding: 10px 12px;\n  resize: none;\n  background: #ffffff;\n}\n\n.pj-new-drawer__textarea.ant-input:focus {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.pj-new-drawer__error {\n  margin: 0;\n  font-size: 12px;\n  color: #E11D48;\n}\n\n.pj-new-drawer__empty {\n  padding: 12px;\n  text-align: center;\n  font-size: 13px;\n  color: #64748B;\n}\n\n.pj-new-drawer__existing {\n  border: 1px solid #BAE6FD;\n  background: #F0F9FF;\n  color: #0284C7;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  text-align: start;\n  cursor: pointer;\n}\n\n.pj-new-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n  box-shadow: 0 -1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.pj-new-drawer__sync {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.pj-new-drawer__sync-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #10B981;\n  flex-shrink: 0;\n}\n\n.pj-new-drawer__footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pj-new-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.pj-new-drawer__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pj-new-drawer__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.pj-new-drawer__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.pj-new-drawer__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.pj-new-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n@media (max-width: 640px) {\n  .pj-new-drawer__grid,\n  .pj-new-drawer__meta-row,\n  .pj-new-drawer__triage {\n    grid-template-columns: 1fr;\n  }\n\n  .pj-new-drawer__step-cats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .pj-new-drawer__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pj-new-drawer__footer-actions {\n    justify-content: flex-end;\n  }\n}\n\n/* ——— Write / view service result drawer (Stitch Clinical Precision) ——— */\n.pj-result-drawer.ant-drawer .ant-drawer-content-wrapper {\n  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.08);\n}\n\n.pj-result-drawer .ant-drawer-header {\n  display: none;\n}\n\n.pj-result-drawer .ant-drawer-body {\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n.pj-result-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: #ffffff;\n}\n\n.pj-result-drawer__header {\n  flex-shrink: 0;\n  padding: 16px 20px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.pj-result-drawer__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.pj-result-drawer__title-block {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pj-result-drawer__title-line {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-width: 0;\n}\n\n.pj-result-drawer__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #0F172A;\n}\n\n.pj-result-drawer__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.pj-result-drawer__icon-btn {\n  box-sizing: border-box;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748B;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.pj-result-drawer__icon-btn:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.pj-result-drawer__icon-btn--bordered {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n[dir='rtl'] .pj-result-drawer__icon-btn--bordered .lucide {\n  transform: scaleX(-1);\n}\n\n.pj-result-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #ffffff;\n}\n\n.pj-result-drawer__banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 8px;\n  background: #F0F9FF;\n  border: 1px solid #BAE6FD;\n  color: #0F172A;\n}\n\n.pj-result-drawer__banner .lucide {\n  color: #0EA5E9;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.pj-result-drawer__banner p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #475569;\n}\n\n.pj-result-drawer__service {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.pj-result-drawer__service-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #E0F2FE;\n  color: #0284C7;\n  flex-shrink: 0;\n}\n\n.pj-result-drawer__service-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.pj-result-drawer__service-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.pj-result-drawer__service-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pj-result-drawer__order-chip {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 6px;\n  background: #E2E8F0;\n  color: #334155;\n}\n\n.pj-result-drawer__field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pj-result-drawer__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.pj-result-drawer__req {\n  color: #E11D48;\n  margin-inline-start: 2px;\n}\n\n.pj-result-drawer__textarea,\n.pj-result-drawer__view {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  font-size: 13px;\n  line-height: 1.55;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #0F172A;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.pj-result-drawer__textarea {\n  resize: vertical;\n  min-height: 180px;\n}\n\n.pj-result-drawer__textarea:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.pj-result-drawer__textarea::placeholder {\n  color: #94A3B8;\n  font-family: inherit;\n}\n\n.pj-result-drawer__view {\n  background: #F8FAFC;\n  min-height: 140px;\n}\n\n.pj-result-drawer__hint {\n  margin: 0;\n  font-size: 11px;\n  color: #94A3B8;\n  line-height: 1.4;\n}\n\n.pj-result-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n  box-shadow: 0 -1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.pj-result-drawer__sync {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n  min-width: 0;\n}\n\n.pj-result-drawer__sync-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #10B981;\n  flex-shrink: 0;\n}\n\n.pj-result-drawer__footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.pj-result-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.pj-result-drawer__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pj-result-drawer__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.pj-result-drawer__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.pj-result-drawer__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.pj-result-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n@media (max-width: 640px) {\n  .pj-result-drawer__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pj-result-drawer__footer-actions {\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
